import FormatPrice from '../Helpers/FormatPrice';
import { NavLink, useNavigate } from "react-router-dom";
import { Button } from '../styles/Button';
import { useAuthStore } from '../store/store';
import axios from 'axios';
import toast,{Toaster} from 'react-hot-toast';

 const API=`${process.env.REACT_APP_SERVER_DOMAIN}/api/products`;
 const deleteProduct = async (id) => {
  try {
    const token = localStorage.getItem("token"); // assuming you store token after login
    const response = await fetch(`${API}/deleteproduct/${id}`, {
      method: "DELETE",
      headers: {
        "Authorization": `Bearer ${token}`, // 👈 send token here
      },
    });

    if (!response.ok) {
      throw new Error("Failed to delete product");
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};
 

const Product = ( { _id,SKU, main,subcategory ,Item,name, price,isDeleted}) => {
const navigate=useNavigate();
const handleDelete = async () => {
  if (window.confirm("Are you sure you want to delete this product?")) {
    try {
      await deleteProduct(_id); // call DELETE API
      toast.success("Product marked as deleted!");
      navigate("/products"); // redirect back to product list
    } catch (error) {
      toast.error("Error deleting product");
      console.error(error);
    }
  }
};

const {auth}=useAuthStore();  
  

return (
   
    <NavLink to={`/SingleProduct/${SKU}`}>
    <div className="card">    
         <figure>
           <img src={main}  alt={subcategory} />
           <figcaption className="caption">{Item}</figcaption>
         </figure>

         <div className="card-data">
           <div className="card-data-flex">
             <h3>{SKU} {name}</h3>
             <p className="card-data--price">{<FormatPrice price={price} user={auth}/>}</p>
           </div>
         </div>
        
         {auth.isLoggedIn && auth.role === "admin" && isDeleted &&(
         <p style={{color:'red'}}>Product deleted</p>)}
       <div className="two-button">
          {auth.isLoggedIn && auth.role === "admin" && (
            <>
              <NavLink to={`/editproductform/${SKU}`}>
                <Button 
                >
                  Edit
                </Button>
              </NavLink>

              <Button className="btn btn-two"
                type="button"
                onClick={handleDelete}>
                {isDeleted ? "Deleted" : "Delete"}
              </Button>
            </>
          )}
       </div>
    </div>
    </NavLink>
)
}
 

 export default Product
